<template>
  <div class="intro-container">
    <h1 class="intro-title">인생의 역점 소개</h1>
    <p class="intro-description">
      <!-- 서비스 전체를 요약한 소개 내용 -->
      인생의 역점은 다음의 서비스들을 통해, 이 순간 여러분 내면의 상태와
      여러분 주변을 흐르는 기운을 분석하여 삶의 나아갈 바를 제시합니다.
    </p>

    <div class="service-introductions-box">
      <!-- 새로운 클래스 이름 또는 기존 클래스 수정 -->
      <div class="service-item">
        <h3>효(爻)로 보는 실시간 운세</h3>
        <p>당신의 기운이 선택한 주역 괘와 효로 지금 이 순간의 운을 풀어드립니다.</p>
      </div>
      <div class="service-item">
        <h3>날씨/시간/체질과 사주</h3>
        <p>
          당신의 사주와 어울려 주변에 흐르는 오행의 기운을 해석하고 그에 순응하는 삶의 지침을
          제공합니다.(현재 위치의 날씨를 파악하기 위해 위치정보를 사용합니다.)
        </p>
      </div>
      <div class="service-item">
        <h3>{{ yearTitle }}</h3>
        <p>
          당신의 사주에 들어있는 십신과 격국을 파악하고 {{ targetYear }}년에 드는 천간 지지가 
          당신의 사주에 미치는 영향을 고려하여 한 해의 세운을 풀어줍니다.
        </p>
      </div>
      <div class="service-item">
        <h3>사주로 풀어보는 MBTI</h3>
        <p>
          동양철학의 기질 분류 체계(사주)와 현대 심리학의 성격 분류 체계(MBTI)의 접점을 찾아
          설문에 흔들리지 않는 안정적인 MBTI 해석을 제공합니다.        
        </p>
      </div>
      <div class="service-item">
        <h3>내가 보는 주역(周易)점</h3>
        <p>
          내 스스로를 위해, 그리고 가끔은 다른 사람을 위해 마음을 담아 주역점을 쳐 보세요. 
          해석은 인생의 역점에서 해 드립니다.
        </p>
      </div>
      <div class="service-item">
        <h3>64괘상(卦像) 공부</h3>
        <p>
          주역 상경(30괘)·하경(34괘) 전체 64괘의 각 괘상이 나타내는 상징과 의미를 간단히 해설해 드립니다.
        </p>
      </div>
      <div class="service-item">
        <h3>언집(言集)</h3>
        <p>나와 내 주변을 돌아볼 수 있는 시간을 가지게 해주는 말 모음입니다.</p>
      </div>
      <div class="service-item">
        <h3>인생의 역점 무료 채널</h3>
        <p>
          인생의 역점에서 제공하는 다양한 무료 컨텐츠 들을 확인하세요. 무료 앱, 블로그, 유투브, 틱톡, 챗GPT 등의 서비스가 제공됩니다.
        </p>
      </div>
      <p class="recovery"><mark>복구코드</mark>를 통한 계정 복구는 메뉴 화면 우측 상단의 <mark>설정 메뉴</mark>를 이용해 주세요.</p>
    </div>
    <div class="button-area">
      <button @click="goBack">돌아가기</button>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { getGanjiByYear } from '@/utils/utils.js'

  const router = useRouter()
  const userType = ref('')

  const yearTitle = ref('')
  const now = new Date()
  const thisYear = now.getFullYear()
  const month = now.getMonth() + 1

  // 11~12월은 미리 내년 운세를 보여줌
  const targetYear = month >= 11 ? thisYear + 1 : thisYear

  const ganji = getGanjiByYear(targetYear)

  yearTitle.value = `올해(${targetYear} ${ganji})의 운세`

  const goBack = () => {
    router.go(-1)
  }
</script>

<style scoped>
  .intro-container {
    min-height: 100vh;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1.2rem;
    box-sizing: border-box;
    text-align: center;
  }

  .intro-title {
    font-size: var(--font-size-14); /* 폰트 크기 조정 */
    margin: 0.5rem 0 0.5rem 0;
    font-weight: bold;
    align-self: center; /* 타이틀만 가운데 정렬 */
  }

  .intro-description {
    font-size: var(--font-size-10);
    line-height: 1.6;
    margin-bottom: 0.5rem;
    width: 90%;
  }

  .service-introductions-box {
    /* 박스 스타일 추가 */
    border: 1px solid #ccc; /* 테두리 색상 및 두께 */
    padding: 0.8rem 1.2rem; /* 내부 여백 */
    margin-bottom: 1.2rem; /* 하단 간격 추가 */
    width: auto; /* 너비를 자동으로 설정하거나 필요에 따라 조정 */
    align-self: center; /* intro-container 내에서 가운데 정렬 */
  }

  .service-item {
    margin-bottom: 10px; /* 간격 축소 */
    text-align: left; /* 왼쪽 정렬 */
  }

  .service-item h3 {
    font-size: var(--font-size-12); /* 폰트 크기 조정 */
    margin-bottom: 3px; /* 간격 축소 */
    font-weight: bold;
  }

  .service-item p {
    font-size: var(--font-size-10); /* 폰트 크기 조정 */
    color: #555;
    margin-bottom: 0; /* 하단 간격 제거 */
    display: inline; /* 인라인 요소로 만들어 옆에 붙게 함 */
  }

  .recovery {
    font-size: var(--font-size-10);
    color: #888;
    margin-top: 1rem;
    text-align: center;
  }

  .button-area {
    margin-top: auto; /* Push button to the bottom */
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }

  button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #f44336;
    color: white;
    cursor: pointer;
  }

  button:hover {
    background-color: #da190b;
  }
</style>
